/**
 * ERPSelectSearchModal
 *
 * Modal padronizado de busca e seleção com o mesmo design da página de Pré-Venda.
 */

import { X, Search, Loader2 } from 'lucide-react'
import './ERPSelectSearchModal.css'

function ERPSelectSearchModal({
  isOpen,
  onClose,
  title,
  subtitle,
  hint,
  icon,
  searchPlaceholder = 'Buscar...',
  searchTerm = '',
  onSearchChange,
  loading = false,
  showSearch = true,
  footer,
  children
}) {
  if (!isOpen) return null

  return (
    <div className="erp-select-modal-overlay" onClick={onClose}>
      <div className="erp-select-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="erp-select-modal-header">
          <div className="erp-select-modal-header-left">
            {icon && <div className="erp-select-modal-icon">{icon}</div>}
            <div>
              <h3 className="erp-select-modal-title">{title}</h3>
              {subtitle && <p className="erp-select-modal-subtitle">{subtitle}</p>}
              {hint && <p className="erp-select-modal-hint">{hint}</p>}
            </div>
          </div>
          <button type="button" onClick={onClose} className="erp-select-modal-close" aria-label="Fechar">
            <X size={24} />
          </button>
        </div>

        <div className="erp-select-modal-body">
          {showSearch && (
            <div className="erp-select-modal-search-box">
              <Search size={18} className="erp-select-modal-search-icon" />
              <input
                type="text"
                className="erp-select-modal-search-input"
                placeholder={searchPlaceholder}
                value={searchTerm}
                onChange={(e) => onSearchChange?.(e.target.value)}
                autoFocus
              />
              {loading && (
                <div className="erp-select-modal-search-loading">
                  <Loader2 size={16} className="spinning" />
                </div>
              )}
            </div>
          )}

          <div className="erp-select-modal-list">
            {children}
          </div>
        </div>

        {footer && <div className="erp-select-modal-footer">{footer}</div>}
      </div>
    </div>
  )
}

export function ERPSelectModalItem({ selected, onClick, avatar, name, detail, checkIcon }) {
  return (
    <div
      className={`erp-select-modal-item ${selected ? 'selected' : ''}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick?.()
        }
      }}
    >
      {avatar && <div className="erp-select-modal-item-avatar">{avatar}</div>}
      <div className="erp-select-modal-item-info">
        <div className="erp-select-modal-item-name">{name}</div>
        {detail && <div className="erp-select-modal-item-detail">{detail}</div>}
      </div>
      {selected && checkIcon}
    </div>
  )
}

export function ERPSelectModalEmpty({ icon, message }) {
  return (
    <div className="erp-select-modal-empty">
      {icon}
      <p>{message}</p>
    </div>
  )
}

export default ERPSelectSearchModal
